import React from 'react';
import { ExecutivesMessage } from '../../../domain/richMessage.interface';
import { TextCard } from './TextCard';

interface ExecutivesCardProps {
  data: ExecutivesMessage;
}

export const ExecutivesCard: React.FC<ExecutivesCardProps> = ({ data }) => (
  <div>
    <TextCard message={data.text} />
    <div className="flex flex-col gap-2 mt-2">
      {data.executives.map((exec, i) => (
        <div key={i} className="bg-grey-96 rounded-xl p-3 flex items-center gap-3">
          {exec.image_url
            ? <img src={exec.image_url} alt={exec.name} className="w-10 h-10 rounded-full object-cover flex-shrink-0" />
            : <div className="w-10 h-10 rounded-full bg-grey-91 flex-shrink-0" />
          }
          <div className="flex-1 min-w-0">
            <p className="text-navy font-bold text-sm leading-tight">{exec.name}</p>
            <p className="text-navy-64 text-xs mt-0.5">{exec.role}</p>
            <a
              href={exec.linkedin_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 border border-coral text-coral text-xs rounded-pill px-3 py-0.5 mt-1.5 hover:bg-coral/5 transition-colors"
            >
              LinkedIn
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
);
